import LitigationImage from "../../Assets/images/LMT.svg";
import ContractImage from "../../Assets/images/CMT.svg";
import NoticeImage from "../../Assets/images/NMT.svg";
import IprImage from "../../Assets/images/IPR.svg";

export const AUTH_FOOTER_LINKS = {
  privacy: "https://legistify.com/privacy",
  terms: "https://legistify.com/terms",
  security: "https://legistify.com/corporate/security",
};

export const LOGIN_SIDE_PANEL_VARIANTS = {
  NEW: "new",
  LEGACY: "legacy",
};

/** Controlled via REACT_APP_LOGIN_SIDE_PANEL_VARIANT (`legacy` | `new`). Defaults to `legacy`. */
const REACT_APP_LOGIN_SIDE_PANEL_VARIANT = "new";
export const LOGIN_SIDE_PANEL_VARIANT = Object.values(LOGIN_SIDE_PANEL_VARIANTS).includes(
  REACT_APP_LOGIN_SIDE_PANEL_VARIANT
)
  ? REACT_APP_LOGIN_SIDE_PANEL_VARIANT
  : LOGIN_SIDE_PANEL_VARIANTS.LEGACY;

export const isLoginSidePanelLegacy = () =>
  LOGIN_SIDE_PANEL_VARIANT === LOGIN_SIDE_PANEL_VARIANTS.LEGACY;

export const LOGIN_SIDE_CAROUSEL_SLIDES = [
  { id: "litigation", src: LitigationImage, alt: "Litigation Management" },
  { id: "contract", src: ContractImage, alt: "Contract Management" },
  { id: "notice", src: NoticeImage, alt: "Notice Management" },
  { id: "ipr", src: IprImage, alt: "IPR Management" },
];

export const LOGIN_SIDE_MODULES = [
  {
    id: "lmt_widget_read-more-btn",
    label: "Litigation & matter tracking",
    href: `${process.env.REACT_APP_LANDING_PAGE_URL}corporate/enterprise-legal-management`,
  },
  {
    id: "contract_widget_read-more-btn",
    label: "Contract lifecycle",
    href: `${process.env.REACT_APP_LANDING_PAGE_URL}corporate/enterprise-contract-management`,
  },
  {
    id: "notice_widget_read-more-btn",
    label: "Notice management",
    href: `${process.env.REACT_APP_LANDING_PAGE_URL}corporate/enterprise-notice-management`,
  },
  {
    id: "IPR_widget_read-more-btn",
    label: "IP portfolio management",
    href: `${process.env.REACT_APP_LANDING_PAGE_URL}corporate/enterprise-ip-portfolio-management`,
  },
];
